// extracted by mini-css-extract-plugin
export default {"returnTop":"ReturnTop_returnTop__z5cLW","icon":"ReturnTop_icon__i0jsk"};